export default "/images/b124738ad0eb3005e8b58656cfb9eb39.avif";